module.exports = __webpack_public_path__ + "static/media/LOGO.974c6fde.png";